import { invoiceFinancingContractorConstants } from '../constants';

const initialState = {
  loading: true,
  errorCode: null,
};

export const invoiceFinancingContractor = (state = initialState, action) => {
  switch (action.type) {
    case invoiceFinancingContractorConstants.GET_INVOICE_FINANCING_CONTRACTOR_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        errorCode: null,
      };
    case invoiceFinancingContractorConstants.GET_INVOICE_FINANCING_CONTRACTOR_FAILED:
      return {
        ...state,
        loading: false,
        errorCode: action.payload.errorCode,
      };
    case invoiceFinancingContractorConstants.SET_INVOICE_FINANCING_CONTRACTOR_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
